import BackspaceIcon from "@mui/icons-material/Backspace";
import EditIcon from "@mui/icons-material/Edit";
import {Typography} from "@mui/material";
import {PuiDialog, PuiFileField, PuiFormikForm, PuiGrid, PuiLoadingBackdrop,} from "@portnet/ui";
import {Formik} from "formik";
import _ from "lodash";
import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router";
import AppSelect from "../../../../common/components/inputs/AppSelect";
import AppTextField from "../../../../common/components/inputs/AppTextField";
import AppButton from "../../../../common/components/ui/AppButton";
import AppSection from "../../../../common/components/ui/AppSection";
import {CONSULTATION_SOUSCRIPTIONS_PAGE_ROUTE} from "../../../../common/constants/routerConstants";
import {confirmerPaiementSouscriptionInitialValues} from "../others/confimerPaiementSouscriptionInitialValues";
import {confimerPaiementSouscriptionValidationSchema} from "../others/confirmerPaiementSouscriptionValidationSchema";
import {getFactureSouscriptionAction} from "../../paiementSouscription/state/paiementSouscriptionActions";
import {
    confirmerPaiementSouscriptionAction,
    confirmerPaiementSouscriptionReinitializationAction,
} from "../state/confirmerPaiementSouscriptionActions";

const ConfimerPaiementSouscription = ({ open, close, selected }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    isLoading: isConfirmationSouscriptionLoading,
    isSuccessed: isConfirmationSouscriptionSuccessed,
    error: isConfirmationSouscriptionFailed,
  } = useSelector(
    (state) =>
      state.souscription.confirmerPaiementSouscription
        .confirmerPaiementSouscription
  );

  const {
    content: factureData,
    isLoading: isFactureDataLoading,
    isSuccessed: isFactureDataSuccessed,
  } = useSelector((state) => state.souscription.paiementSouscription.facture);

  const formRef = React.useRef();
  const submitHandler = (values) => {
    let souscriptionPayee = _.pick(values, [
      "moyenPaiement",
      "commentaire",
      "file",
    ]);
    souscriptionPayee["idSouscription"] = selected?.id;
    dispatch(confirmerPaiementSouscriptionAction(souscriptionPayee));
  };
  React.useEffect(() => {
    if (isConfirmationSouscriptionSuccessed) {
      dispatch(confirmerPaiementSouscriptionReinitializationAction());
      navigate(CONSULTATION_SOUSCRIPTIONS_PAGE_ROUTE);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isConfirmationSouscriptionSuccessed, isConfirmationSouscriptionFailed]);

  React.useEffect(() => {
    dispatch(getFactureSouscriptionAction(selected?.id));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  return (
    <>
      <PuiLoadingBackdrop open={isConfirmationSouscriptionLoading } />
      <PuiDialog
        onClose={close}
        open={open}
        maxWidth="lg"
        loading = {isFactureDataLoading}
        fullWidth
        title="Confirmer le paiement de la souscription"
      >
        <Formik
          initialValues={confirmerPaiementSouscriptionInitialValues}
          validationSchema={confimerPaiementSouscriptionValidationSchema}
          onSubmit={submitHandler}
          innerRef={formRef}
        >
          <PuiFormikForm>
            <AppSection>
              <PuiGrid container>
                <PuiGrid item xs={12} sm={12} md={12} sx={{ marginBottom: 2 }}>
                  <Typography
                    variant="h2"
                    sx={{
                      fontSize: "1em",
                      fontWeight: 600,
                      textAlign: "center",
                      color: "success.main",
                    }}
                  >
                    Votre achat ne sera validé qu'aprés l'encaissement effectif
                    du montant par PORTNET S.A. Vous pouvez payer en ligne pour
                    une prise en charge instantannée de votre paiement.
                  </Typography>
                </PuiGrid>
                <PuiGrid item xs={12} sm={6} md={6}>
                  <AppTextField
                    label="Code du package"
                    value={selected?.codePackage}
                    formik={false}
                    readOnly
                  />
                </PuiGrid>
                <PuiGrid item xs={12} sm={6} md={6}>
                  <AppTextField
                    label="Identifiant de la sousciption"
                    value={selected?.identifiantSouscription}
                    formik={false}
                  />
                </PuiGrid>
                <PuiGrid item xs={12} sm={6} md={6}>
                  <AppSelect
                    name={"moyenPaiement"}
                    label="Type de paiement"
                    options={[{ description: "Virement", value: "Virement" }]}
                    getOptionLabel={(option) => option.description}
                    getOptionValue={(option) => option.value}
                    required
                  />
                </PuiGrid>
                <PuiGrid item xs={12} sm={6} md={6}>
                  <AppTextField
                    label="Montant"
                    value={factureData[0]?.importeTTC}
                    formik={false}
                  />
                </PuiGrid>
                <PuiGrid item xs={12} sm={12} md={12}>
                  <AppTextField
                    label="Commentaire"
                    name="commentaire"
                    multiline
                    rows={6}
                  />
                </PuiGrid>
                <PuiGrid item xs={12} sm={6} md={6}>
                  <PuiFileField
                    accept=".pdf"
                    buttonText="Sélectionner"
                    fullWidth
                    label="Ajouter une PJ"
                    name="file"
                    formik
                    required
                    formatValue={(files) => files[0]}
                  />
                </PuiGrid>
              </PuiGrid>
            </AppSection>
            <AppSection sx={{ marginTop: 2, padding: 1 }}>
              <PuiGrid container justifyContent="flex-end">
                <PuiGrid item>
                  <AppButton
                    color="tertiary"
                    startIcon={<BackspaceIcon />}
                    onClick={() => {
                      formRef.current.resetForm();
                    }}
                  >
                    Effacer
                  </AppButton>
                </PuiGrid>
                <PuiGrid item>
                  <AppButton
                    color="primary"
                    startIcon={<EditIcon />}
                    onClick={() => {
                      formRef.current.submitForm();
                    }}
                  >
                    Valider
                  </AppButton>
                </PuiGrid>
              </PuiGrid>
            </AppSection>
          </PuiFormikForm>
        </Formik>
      </PuiDialog>
    </>
  );
};
export default ConfimerPaiementSouscription;
